export const menu = {
  sectionModule: [
    {
      name: 'clone',
      icon: 'fa-copy',
      method: 'copyElement',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'add-row',
      icon: 'fa-grip-lines',
      method: 'addRow',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'move',
      icon: 'fa-arrows-alt',
      method: null,
      classes: ['section-handle'],
      menu: null,
    },
    {
      name: 'delete',
      icon: 'fa-trash-alt',
      method: 'removeParent',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'settings',
      icon: 'fa-cog',
      hoverable: true,
      method: 'openMenu',
      classes: [],
      menu: 'SectionMenu',
    }
  ],
  rowModule: [
    {
      name: 'clone',
      icon: 'fa-copy',
      method: 'copyElement',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'add-columns',
      icon: 'fa-columns',
      method: null,
      classes: [],
      hoverable: true,
      menu: 'row-columns-menu',
    },
    {
      name: 'move',
      icon: 'fa-arrows-alt',
      method: null,
      classes: ['row-handle'],
      hoverable: false,
      menu: null,
    },
    {
      name: 'delete',
      icon: 'fa-trash-alt',
      method: 'removeParent',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'settings',
      icon: 'fa-cog',
      method: 'openMenu',
      classes: [],
      hoverable: true,
      menu: 'row-menu',
    }
  ],
  columnModule: [
    {
      name: 'add-component',
      icon: 'fa-plus',
      method: 'addComponent',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'move',
      icon: 'fa-arrows-alt',
      method: null,
      classes: ['column-handle'],
      hoverable: false,
      menu: null,
    },
    {
      name: 'delete',
      icon: 'fa-trash-alt',
      method: 'removeParent',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'settings',
      icon: 'fa-cog',
      method: 'openMenu',
      classes: [],
      hoverable: true,
      menu: 'column-menu',
    }
  ],
  componentModule: {
    'editor-accordion': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'accordion-menu',
      }
    ],
    'editor-alert': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'alert-menu',
      }
    ],
    'editor-button': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'button-menu',
      }
    ],
    'editor-carousel': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'carousel-menu',
      }
    ],
    'editor-form': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'form-menu',
      }
    ],
    'editor-google-maps': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'google-maps-menu',
      }
    ],
    'editor-heading': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'heading-menu',
      }
    ],
    'editor-html-code': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'html-code-menu',
      }
    ],
    'editor-icon': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'icon-menu',
      },
    ],
    'editor-lists': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'lists-menu',
      }
    ],
    'editor-progress-bar': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'progress-bar-menu',
      }
    ],
    'editor-separator': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'separator-menu',
      }
    ],
    'editor-single-image': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'single-image-menu',
      }
    ],
    'editor-tabs': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'tabs-menu',
      }
    ],
    'editor-text': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'text-editor-menu',
      }
    ],
    'editor-video': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'video-menu',
      }
    ],
  },
  componentRowModule: [
    {
      name: 'clone',
      icon: 'fa-copy',
      method: 'copyElement',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'add-columns',
      icon: 'fa-columns',
      method: null,
      classes: [],
      hoverable: true,
      menu: 'component-row-columns-menu',
    },
    {
      name: 'move',
      icon: 'fa-arrows-alt',
      method: null,
      classes: ['component-row-handle'],
      hoverable: false,
      menu: null,
    },
    {
      name: 'delete',
      icon: 'fa-trash-alt',
      method: 'removeParent',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'settings',
      icon: 'fa-cog',
      method: 'openMenu',
      classes: [],
      hoverable: true,
      menu: 'component-row-menu',
    }
  ],
  componentColumnModule: [
    {
      name: 'add-component',
      icon: 'fa-plus',
      method: 'addComponent',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'move',
      icon: 'fa-arrows-alt',
      method: null,
      classes: ['component-column-handle'],
      hoverable: false,
      menu: null,
    },
    {
      name: 'delete',
      icon: 'fa-trash-alt',
      method: 'removeParent',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
      name: 'settings',
      icon: 'fa-cog',
      method: 'openMenu',
      classes: [],
      hoverable: true,
      menu: 'component-column-menu',
    }
  ],
  componentComponentModule: {
    'heading-editor': [
      {
      name: 'clone',
      icon: 'fa-copy',
      method: 'copyElement',
      classes: [],
      hoverable: false,
      menu: null,
    },
    {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'heading-editor-menu',
      }
    ],
    'button-editor': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'button-editor-menu',
      }
    ],
    'single-image-editor': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'single-image-editor-menu',
      }
    ],
    'editor-icon': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'icon-menu',
      },
    ],
    'editor-text': [
      {
        name: 'move',
        icon: 'fa-arrows-alt',
        method: null,
        classes: ['component-handle'],
        hoverable: false,
        menu: null,
      },
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
    ],
  },
  pageComponentModule: {
    'editor-pop-up': [
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'pop-up-menu',
      }
    ],
    'editor-social-proof-bubble': [
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'social-proof-bubble-menu',
      }
    ],
    'editor-banner': [
      {
        name: 'delete',
        icon: 'fa-trash-alt',
        method: 'removeParent',
        classes: [],
        hoverable: false,
        menu: null,
      },
      {
        name: 'settings',
        icon: 'fa-cog',
        method: 'openMenu',
        classes: [],
        hoverable: true,
        menu: 'banner-menu',
      }
    ],
  }
}
